import { VISA } from './VISA'
import { MasterCard } from './MasterCard'
import { Swish } from './Swish'
import { PaymentTypes, SupportedPaymentMethod } from '../../pages/overview/util/useFetchSupportedPaymentMethods'
import { IDealWero } from './IDealWero'

const iconStyles = {
  width: '45px',
}

type Props = {
  paymentMethod: SupportedPaymentMethod
}

export const PaymentType = ({ paymentMethod }: Props) => {
  switch (paymentMethod.type) {
    case PaymentTypes.Ideal:
      return <IDealWero sx={iconStyles} />
    case PaymentTypes.Visa:
      return <VISA sx={iconStyles} />
    case PaymentTypes.MasterCard:
      return <MasterCard sx={iconStyles} />
    case PaymentTypes.Swish:
      return <Swish sx={iconStyles} />
    case PaymentTypes.CreditCard:
      return (
        <>
          <VISA sx={iconStyles} />
          <MasterCard sx={iconStyles} />
        </>
      )
    default:
      throw new Error(`Unknown payment type: ${paymentMethod}`)
  }
}
